import {
  Plus, Trash2 
} from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { RecipeFormData } from './form-types';

interface InstructionsTabProps {
  readonly formData: RecipeFormData;
  readonly updateField: <K extends keyof RecipeFormData>(field: K, value: RecipeFormData[K]) => void;
}

export function InstructionsTab({
  formData, updateField 
}: InstructionsTabProps) {
  const addInstruction = () => {
    updateField('instructions', [...formData.instructions, '']);
  };

  const updateInstruction = (index: number, value: string) => {
    const newInstructions = [...formData.instructions];
    newInstructions[index] = value;
    updateField('instructions', newInstructions);
  };

  const removeInstruction = (index: number) => {
    if (formData.instructions.length > 1) {
      updateField('instructions', formData.instructions.filter((_, i) => i !== index));
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">
          Add step-by-step cooking instructions.
        </p>
        <Button onClick={addInstruction} size="sm">
          <Plus className="mr-2 h-4 w-4" />
          Add Step
        </Button>
      </div>

      <div className="space-y-3">
        {formData.instructions.map((instruction, index) => (
          <div key={`step-${index.toString()}`} className="flex items-start gap-3">
            <span className="flex-shrink-0 w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center text-sm font-medium">
              {index + 1}
            </span>
            <textarea
              value={instruction}
              onChange={(e) => updateInstruction(index, e.target.value)}
              placeholder={`Step ${index + 1}...`}
              rows={2}
              className="flex-1 rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
            />
            <button
              type="button"
              onClick={() => removeInstruction(index)}
              disabled={formData.instructions.length === 1}
              className="flex-shrink-0 p-1.5 text-red-500 hover:bg-red-50 rounded transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
            >
              <Trash2 className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
